import { render, staticRenderFns } from "./ProfileIndex.vue?vue&type=template&id=afa5891a&scoped=true&"
import script from "./ProfileIndex.vue?vue&type=script&lang=js&"
export * from "./ProfileIndex.vue?vue&type=script&lang=js&"
import style0 from "./ProfileIndex.vue?vue&type=style&index=0&id=afa5891a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa5891a",
  null
  
)

export default component.exports